export default [
  // *===============================================---*
  // *--------- STOWAGES -------------------------------------------*
  // *===============================================---*
  {
    path: '/detalle-estiba/:stowage_id',
    name: 'stowage-detail',
    component: () => import('@/views/stowages/detail/StowageDetail.vue'),
  },

  // *===============================================---*
  // *--------- VALIDATE REPEATED -------------------------------------------*
  // *===============================================---*
  {
    path: '/validar-repetidos/:stowage_id',
    name: 'validate-repeated',
    component: () => import('@/views/stowages/validate-repeated/ValidateRepeated.vue'),
  },
]